module.exports = __webpack_public_path__ + "img/logo-half.313d65ed.svg";